export interface ICycle {
  readonly id: string
  readonly name: string
}
